import { gql, useLazyQuery } from '@apollo/client';
import { DateRangePickerProps } from '@amzn/awsui-components-react';
import moment from 'moment';

interface FleetMetricsData {
  timestamp: string;
  metrics: Record<string, any>[];
}

export interface JunoFleetMetricsPCVars {
  placementConstraintId: string;
  dataPlaneType: string;
  awsAccountId: string;
  namespace: string;
  flavor: string;
  startTime: string;
  endTime: string;
}

interface JunoFleetMetricsDataPCResponse {
  getJunoFleetMetricsPC: FleetMetricsData[];
}

const GET_JUNO_Fleet_METRICS_PC = gql`
  query GetJunoFleetMetricsPC(
    $placementConstraintId: String!
    $dataPlaneType: String!
    $awsAccountId: String!
    $namespace: String!
    $flavor: String!
    $startTime: String!
    $endTime: String!
  ) {
    getJunoFleetMetricsPC(
      placementConstraintId: $placementConstraintId
      dataPlaneType: $dataPlaneType
      awsAccountId: $awsAccountId
      namespace: $namespace
      flavor: $flavor
      startTime: $startTime
      endTime: $endTime
    ) {
      timestamp
      metrics
    }
  }
`;

export const useJunoFleetMetricsPCQuery = () => {
  const [getJunoFleetMetricsPC, queryResult] = useLazyQuery<
    JunoFleetMetricsDataPCResponse,
    JunoFleetMetricsPCVars
  >(GET_JUNO_Fleet_METRICS_PC, {
    errorPolicy: 'all',
    fetchPolicy: 'no-cache'
  });

  const fetchData = (
    timeRange: DateRangePickerProps.Value,
    params: {
      placementConstraintId: string;
      dataPlaneType: string;
      awsAccountId: string;
      namespace: string;
      flavor: string;
    }
  ) => {
    let startTime: string;
    let endTime: string;
  
    if (timeRange.type === 'absolute') {
      startTime = moment(timeRange.startDate).format('YYYY-MM-DDTHH:mm:ss');
      endTime = moment(timeRange.endDate).format('YYYY-MM-DDTHH:mm:ss');
    } else {
      const relativeValue = timeRange as DateRangePickerProps.RelativeValue;
      endTime = moment().format('YYYY-MM-DDTHH:mm:ss');
      startTime = moment()
        .subtract(relativeValue.amount, relativeValue.unit)
        .format('YYYY-MM-DDTHH:mm:ss');
    }
  
    return getJunoFleetMetricsPC({
      variables: {
        placementConstraintId: params.placementConstraintId,
        dataPlaneType: params.dataPlaneType,
        awsAccountId: params.awsAccountId,
        namespace: params.namespace,
        flavor: params.flavor,
        startTime,
        endTime,
      }
    });
  };

  return {
    ...queryResult,
    fetchData
  };
};

export type { FleetMetricsData };